import { Button, Box, Modal, CardContent, Card } from '@mui/material';

interface ModalTermAndConditionsProps {
    open: boolean;
    handleClose: () => void;
}

export const ModalTermAndConditions = ({
    open,
    handleClose,
}: ModalTermAndConditionsProps) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '90vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    overflow: 'hidden',
                    zIndex: 1300,
                }}
            >
                <Card
                    sx={{
                        backgroundColor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 3,
                        padding: 3,
                        maxHeight: '80vh',
                        maxWidth: 800,
                        width: '100%',
                        overflowY: 'auto',
                        boxSizing: 'border-box',
                    }}
                >
                    <CardContent>
                        <body>
                            <h2>
                                Términos y condiciones de uso de la aplicación
                            </h2>

                            <p>
                                CHATBOT DE SERVICIOS es una solución tecnológica
                                desarrollada y administrada por{' '}
                                <strong>COMWARE</strong>, que tiene como
                                finalidad la prestación de servicios y atención
                                de preguntas frecuentes con funcionalidades de
                                respuesta automatizadas, dirigido a asegurados y
                                público en general de{' '}
                                <strong>LA PREVISORA S.A.</strong>
                            </p>

                            <p>
                                El acceso al CHATBOT DE SERVICIO estará sujeto a
                                los términos y condiciones generales que se
                                establecen a continuación:
                            </p>

                            <h3>USO DEL CHATBOT</h3>

                            <p>
                                Para efectos de los presentes Términos y
                                Condiciones, entiéndase como Usuarios a los
                                consumidores financieros, asegurados, aliados
                                estratégicos, terceros y ciudadanos en general
                                que utilicen la solución.
                            </p>

                            <p>
                                Al acceder, hacer uso del CHATBOT y adquirir los
                                productos o servicios en él ofertados, el
                                usuario acepta y se obliga a cumplir los
                                Términos y Condiciones y las políticas de
                                privacidad y tratamiento de información de{' '}
                                <strong>LA PREVISORA S.A.</strong> disponibles
                                en la página web{' '}
                                <a
                                    href="http://www.previsora.gov.co"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.previsora.gov.co
                                </a>{' '}
                                o a través de{' '}
                                <a href="mailto:contactenos@previsora.gov.co">
                                    contactenos@previsora.gov.co
                                </a>{' '}
                                o del teléfono 601 348 7555 (“Términos y
                                Condiciones”).
                            </p>

                            <p>
                                Cada usuario que ingresa al portal acepta de
                                manera directa que es el único responsable en la
                                forma en que dará uso de la información,
                                contenidos, herramientas o enlaces, puestos a
                                disposición en el portal web.
                            </p>

                            <p>
                                <strong>LA PREVISORA</strong> no asumirá
                                responsabilidad por daños y perjuicios de
                                cualquier naturaleza que puedan presentarse por
                                el uso inadecuado de las aplicaciones,
                                servicios, contenidos por parte del usuario, ni
                                por los generados por la ausencia de vigencia,
                                exhaustividad, veracidad o autenticidad de toda
                                la información o contenidos que el usuario pueda
                                compartir o proporcionar a terceros acerca de sí
                                mismo. Tampoco se responsabiliza por los daños y
                                perjuicios derivados por la suplantación de la
                                personalidad de un tercero efectuado por
                                cualquier usuario en cualquier clase de acción
                                realizada a través del CHATBOT DE SERVICIO.
                            </p>

                            <p>
                                Para el uso del CHATBOT, el Usuario declara que
                                los datos e información suministrada son
                                comprensibles, comprobables, actualizados,
                                correctos, completos y ciertos, en consecuencia,
                                el Usuario es responsable por la veracidad de la
                                información suministrada en el CHATBOT. De
                                suministrarse información errónea u omitir
                                información, se dará aplicación a lo dispuesto
                                en el artículo 1058 del Código de Comercio,
                                referente a la reticencia.
                            </p>

                            <p>
                                En todo momento y sin previo aviso,{' '}
                                <strong>LA PREVISORA</strong> podrá modificar
                                los presentes términos y condiciones, mediante
                                la publicación de dichas modificaciones en el
                                CHATBOT DE SERVICIO, con el fin de que sean
                                conocidas por los usuarios. Lo anterior, sin que
                                se genere derecho a indemnización alguna en
                                favor de los usuarios.
                            </p>

                            <h3>PROPIEDAD DEL DESARROLLO</h3>
                            <p>
                                El desarrollo lo realizará y será propiedad del
                                proveedor <strong>COMWARE</strong>
                            </p>

                            <h3>FUNCIONES DEL SERVICIO</h3>
                            <p>
                                Los usuarios que hagan uso del CHATBOT podrán
                                cotizar y comprar productos y servicios
                                ofertados, solicitar información acerca de sus
                                pólizas y de <strong>LA PREVISORA</strong>, y
                                realizar consultas y solicitudes de carácter
                                general que serán atendidas por un asesor.
                            </p>

                            <h3>
                                OBLIGACIONES DEL CREADOR DEL SOFTWARE EN EL
                                MANEJO DEL CHATBOT
                            </h3>
                            <ol className="letras">
                                <li>
                                    Hacer uso de la información suministrada y
                                    autorizada por los Usuarios en el Portal
                                    para los fines relacionados en el presente
                                    documento.
                                </li>
                                <li>
                                    Velar por el correcto uso y suministro de la
                                    información a través del CHATBOT.
                                </li>
                                <li>
                                    Iniciar todas las medidas y acciones legales
                                    contra los Usuarios o terceros por el
                                    incumplimiento, abuso o mal uso de los
                                    Términos y Condiciones del Portal.
                                </li>
                                <li>
                                    No suministrar datos personales de terceros
                                    sin la correspondiente autorización del
                                    titular.
                                </li>
                                <li>
                                    Proveer el servicio bajo buenas prácticas de
                                    desarrollo y parámetros mínimos de seguridad
                                    de información que impidan ataques
                                    cibernéticos y vulnerabilidades en la
                                    información de los usuarios.
                                </li>
                            </ol>

                            <h3>
                                OBLIGACIONES DE LA PREVISORA EN EL MANEJO DEL
                                CHATBOT
                            </h3>
                            <ol className="letras">
                                <li>
                                    Hacer uso de la información suministrada por
                                    los Usuarios en el Portal para los fines
                                    autorizados por aquellos.
                                </li>
                                <li>
                                    Velar por el correcto uso y suministro de la
                                    información que conozca a través del Portal.
                                </li>
                                <li>
                                    Iniciar todas las medidas y acciones legales
                                    contra los Usuarios o terceros por el
                                    incumplimiento, abuso o mal uso de los
                                    Términos y Condiciones del Portal.
                                </li>
                                <li>
                                    No suministrar datos personales de terceros
                                    sin la correspondiente autorización del
                                    titular.
                                </li>
                            </ol>

                            <h3>
                                OBLIGACIONES DEL USUARIO EN EL MANEJO DEL
                                CHATBOT
                            </h3>
                            <ol className="letras">
                                <li>
                                    Hacer uso del CHATBOT únicamente para los
                                    fines autorizados en el presente documento,
                                    así como de la información suministrada a
                                    través de él.
                                </li>
                                <li>
                                    No incurrir, ni desarrollar actividades
                                    fraudulentas a través del servicio de
                                    CHATBOT.
                                </li>
                                <li>
                                    No sustituir la identidad de otro Usuario o
                                    de un tercero.
                                </li>
                                <li>
                                    No transferir a través del CHATBOT
                                    documentos que contengan programas o virus.
                                </li>
                                <li>
                                    No utilizar hardware o software que afecten
                                    en cualquier forma el CHATBOT.
                                </li>
                                <li>
                                    Hacerse responsable por el uso de datos y/o
                                    cobros realizados por proveedores de
                                    internet, para la navegación en el servicio.
                                </li>
                                <li>
                                    Permitir al servicio de CHATBOT usar todos
                                    los dispositivos periféricos que estén
                                    conectados o formen parte del dispositivo
                                    (como cámaras, micrófonos o impresoras) del
                                    Usuario, cuando lo requieran sus funciones.
                                </li>
                                <li>
                                    Conocer la Política de tratamiento de
                                    información definidas por{' '}
                                    <strong>LA PREVISORA S.A.</strong>
                                </li>
                                <li>
                                    Conocer los Términos y Condiciones definidas
                                    por <strong>LA PREVISORA S.A.</strong>
                                </li>
                            </ol>

                            <h3>DISPONIBILIDAD DEL SERVICIO</h3>
                            <p>
                                {' '}
                                <strong>COMWARE</strong> velará por mantener la
                                disponibilidad y continuidad en el
                                funcionamiento del servicio de CHATBOT. En
                                condiciones normales, el servicio funciona de
                                manera continua todos los días, las 24 horas del
                                día, sin perjuicio de que algunos de los
                                procesos para la contratación de las pólizas
                                puedan realizarse únicamente en días y horarios
                                hábiles. <strong>COMWARE</strong> podrá limitar
                                el acceso por mejoras, mantenimiento o
                                restringirlo por falta de funcionalidad de la
                                misma.
                            </p>
                            <p>
                                <strong>COMWARE</strong> y{' '}
                                <strong>LA PREVISORA</strong> no asumen
                                responsabilidad alguna por los daños y
                                perjuicios de toda naturaleza que pudieran
                                derivarse de la utilización inadecuada o
                                negligente de los contenidos y servicios del
                                CHATBOT por parte del usuario, ni por los que
                                puedan derivarse de la falta de veracidad y/o
                                autenticidad de la información que el usuario
                                proporciona a otros usuarios acerca de sí mismos
                                y, en particular, aunque no de forma exclusiva,
                                por los daños y perjuicios de toda naturaleza
                                que puedan derivarse de la suplantación de la
                                personalidad de un tercero efectuada por un
                                usuario en cualquier clase de comunicación
                                realizada a través de éste portal.
                            </p>
                            <p>
                                <strong>COMWARE</strong> y{' '}
                                <strong>LA PREVISORA</strong> no serán
                                responsables con el Usuario, ni terceros, por:
                            </p>
                            <ol className="main-list">
                                <li>Fuerza mayor o caso fortuito.</li>
                                <li>
                                    Errores/omisiones en el uso del CHATBOT por
                                    parte del Usuario.
                                </li>
                                <li>
                                    Perjuicios de todo tipo y/o conceptos
                                    cuantificables y probados, por fallas, no
                                    procesamiento/recepción de información o
                                    suspensión del servicio del operador de
                                    internet o daños en los teléfonos
                                    inteligentes, tablets o cualquier otro tipo
                                    de dispositivo con características
                                    similares.
                                </li>
                            </ol>

                            <h3>
                                SOBRE LOS DERECHOS DE PROPIEDAD INTELECTUAL E
                                INDUSTRIAL DE LA PREVISORA
                            </h3>
                            <p>
                                Al aceptar los Términos y Condiciones, el
                                Usuario declara que, <strong>COMWARE</strong>{' '}
                                detenta la titularidad de los derechos de
                                propiedad intelectual e industrial del CHATBOT
                                DE SERVICIO y sus códigos fuente; y que{' '}
                                <strong>LA PREVISORA</strong> detenta la
                                titularidad de los contenidos, marcas, logos,
                                imágenes y demás asociados a la marca PREVISORA.
                            </p>
                            <p>
                                Adicionalmente, reconoce que el uso y
                                transferencia de datos e información por parte
                                del Usuario al CHATBOT no da al Usuario o a
                                terceros, derecho alguno sobre la propiedad
                                intelectual e industrial respecto al CHATBOT,
                                sus códigos fuente, diseños, contenidos, marcas,
                                logos, imágenes y demás asociados a éste.
                            </p>
                            <p>
                                <strong>COMWARE</strong> y{' '}
                                <strong>LA PREVISORA</strong> podrán iniciar las
                                acciones que correspondan contra el Usuario o
                                terceros que infrinjan los derechos de propiedad
                                intelectual e industrial asociados al CHATBOT.
                            </p>

                            <h3>AUTORIZACIÓN Y TRATAMIENTO DE DATOS</h3>
                            <p>
                                Autorizo expresamente a{' '}
                                <strong>LA PREVISORA S.A</strong> y a{' '}
                                <strong>COMWARE</strong>
                                ., Compañía de Seguros. con NIT. 860002400-2
                                como responsable del tratamiento de la
                                información, para utilizar nombre, teléfono de
                                contacto, correo electrónico y demás datos
                                personales compartidos con esta compañía con las
                                finalidades indicadas a continuación:
                            </p>
                            <ol className="letras">
                                <li>
                                    Realizar gestiones de conocimiento al
                                    cliente y verificación o actualización de
                                    información a través de cualquier medio;
                                </li>
                                <li>
                                    Tramitar solicitudes o recibir información
                                    general, automóviles, SOAT, hogar, áreas
                                    comunes y otros ramos
                                </li>
                                <li>
                                    Enviar correspondencia, correos
                                    electrónicos, mensajes de texto (SMS) o
                                    hacer contacto telefónico en desarrollo de
                                    actividades publicitarias, de mercadeo,
                                    ofrecimiento de productos o servicios nuevos
                                    y actuales;
                                </li>
                                <li>
                                    Compartir esta información con terceros
                                    conforme se haga necesario para realizar
                                    actividades comprendidas dentro de su objeto
                                    social;
                                </li>
                                <li>
                                    Realizar encuestas de satisfacción y
                                    percepción sobre los productos y servicios
                                    de <strong>LA PREVISORA</strong> por
                                    cualquier medio;
                                </li>
                                <li>
                                    Para la prestación de todos los servicios
                                    convenidos dentro del contrato de seguros en
                                    caso de que tenga la calidad de asegurado o
                                    beneficiario.
                                </li>
                            </ol>

                            <p>
                                Especialmente declaro que he recibido
                                información sobre el carácter facultativo de la
                                respuesta a las preguntas que me sean
                                efectuadas, cuando estas versen sobre datos
                                sensibles o sobre datos de niñas, niños y
                                adolescentes, y que de acuerdo con la
                                legislación colombiana vigente en materia de
                                protección de datos personales, como titular de
                                la información tengo derecho a conocer,
                                actualizar, rectificar y suprimir mis datos
                                personales, esto último, en caso de ser posible,
                                al no mediar una relación contractual o legal
                                que impida el retiro de la información, enviando
                                solicitud al correo electrónico{' '}
                                <a href="mailto:contactenos@previsora.gov.co">
                                    contactenos@previsora.gov.co
                                </a>
                                , enviando comunicación escrita a la Calle 57 #
                                9 – 07 en Bogotá, en el teléfono 3487555 o a
                                través del sistema PQR disponible en la página
                                WEB{' '}
                                <a
                                    href="http://www.previsora.gov.co"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.previsora.gov.co
                                </a>
                                .
                            </p>
                            <p>
                                Que como titular de los datos me asisten los
                                derechos establecidos en la ley 1581 de 2012 y
                                sus Decretos reglamentarios o demás normas que
                                la modifiquen, adicionen o complementen, en
                                especial los derechos a: a) Conocer, actualizar
                                y rectificar mis datos b) Solicitar prueba de la
                                autorización otorgada; c) Ser informado del uso
                                que le ha dado a sus datos personales; d)
                                Presentar ante la Superintendencia de Industria
                                y Comercio quejas por infracciones a las
                                disposiciones legales vigentes e) Revocar la
                                autorización y/o solicitar la supresión del dato
                                cuando en el Tratamiento no se respeten los
                                principios, derechos y garantías
                                constitucionales y legales. f) Acceder en forma
                                gratuita a mis datos personales que hayan sido
                                objeto de Tratamiento al menos una vez cada mes
                                calendario y cada vez que existan modificaciones
                                sustanciales de las Políticas de Tratamiento de
                                la información que motiven nuevas consultas.
                            </p>
                            <p>
                                Dejo constancia que se me ha suministrado
                                información comprensible en torno a mis derechos
                                referentes con el tratamiento de mi información
                                personal, en particular el de presentar
                                consultas, peticiones y quejas.
                            </p>
                            <p>
                                La información suministrada permanecerá
                                almacenada por el término máximo necesario para
                                el cumplimiento de las obligaciones legales y/o
                                contractuales, con el fin de atender las
                                disposiciones a los aspectos administrativos,
                                contables, fiscales, jurídicos e históricos de
                                la información.
                            </p>
                            <p>
                                Para más información sobre la Política de
                                privacidad de <strong>LA PREVISORA</strong>, así
                                como los derechos de los titulares de la
                                información y la manera de ejercerlos es posible
                                acceder a la página de internet{' '}
                                <a
                                    href="http://www.previsora.gov.co"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    www.previsora.gov.co
                                </a>
                                .
                            </p>

                            <h3>INFORMACIÓN COMERCIAL</h3>
                            <p>
                                El usuario autoriza expresamente a{' '}
                                <strong>LA PREVISORA</strong> para contactarlo
                                vía correo electrónico, correo postal, mensajes
                                de texto MMS/SMS, WhatsApp o telefónicamente
                                para Ofertas y Publicidad, así como realizar
                                actividades de mercadeo, eventos,
                                capacitaciones, seminarios, talleres y/o
                                actividades de comercialización de servicios y/o
                                productos que preste o que pudiera llegar a
                                ofrecer.
                            </p>

                            <h3>MEDIDAS DE SEGURIDAD</h3>
                            <p>
                                <strong>LA PREVISORA</strong> recomienda al
                                Usuario para hacer uso del portal, tomar las
                                medidas de seguridad suficientes para evitar
                                fraudes electrónicos, tales como:
                            </p>
                            <ol className="letras">
                                <li>
                                    Instalar y actualizar periódicamente
                                    programas de protección de antivirus,
                                    malware, spyware y/u otras.
                                </li>
                                <li>
                                    Evitar hacer transacciones en lugares con
                                    conexiones públicas no seguras como café
                                    internet, sitios WiFi-públicos, colegios,
                                    universidades o usando accesos a internet a
                                    través de redes desconocidas.
                                </li>
                                <li>
                                    Evite el uso de mensajería instantánea y/o
                                    programas de telefonía en línea mientras
                                    efectúa operaciones o consultas por
                                    Internet.
                                </li>
                            </ol>
                            <p>
                                <strong>LA PREVISORA</strong> no se hace
                                responsable por los daños o perjuicios que se
                                puedan presentar por la no aplicación de las
                                debidas medidas de seguridad.
                            </p>
                        </body>
                        <Box
                            sx={{
                                textAlign: 'right',
                                mt: 3,
                            }}
                        >
                            <Button
                                variant="contained"
                                className="modal-card-button"
                                onClick={handleClose}
                            >
                                Acepto
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Modal>
    );
};
